import React from 'react';
import ApplicationActions from '../actions/ApplicationActions.js';
import MoreMenu from './Common/MoreMenu.jsx';
import BackButton from './Common/BackButton.jsx';
import Products from '../utils/Products.js';
import Validators from '../utils/Validators.js';
import DownloadFormsHelper from '../utils/DownloadFormsHelper.js';
import DownloadMenu from './DownloadMenu.jsx';
import ClassNames from 'classnames';
import ReactDOM from 'react-dom';
import SaveApplicationNotification from './SaveApplicationNotification.jsx';
import SlidingSessionNotification from './SlidingSessionNotification.jsx';
import ApplicationErrorNotification from './ApplicationErrorNotification.jsx';
import UrlService from '../services/UrlService';

var saving = false;

function setHeightOfSpacer(element) {
    var navbar, spacer;
    if (element) {
        navbar = element.getElementsByClassName('navbar-header');
        spacer = element.getElementsByClassName('NavigationBar__spacer');
        if (navbar && spacer) {
            spacer[0].style.height = navbar.NavigationBar.scrollHeight.toString() + 'px';
        }
    }
}

var NavigationBar = React.createClass({
    propTypes: {
        product: React.PropTypes.object.isRequired,
        moreMenuContent: React.PropTypes.object.isRequired,
        backButtonUrl: React.PropTypes.func,
        route: React.PropTypes.string,
        application: React.PropTypes.object,
        clientIdentificationMode: React.PropTypes.object,
        canSaveApplication: React.PropTypes.bool.isRequired,
        showMoreMenu: React.PropTypes.bool,
        showDownloadMenu: React.PropTypes.bool,
        accountType: React.PropTypes.string,
        isSaveDisabled: React.PropTypes.bool
    },

    getDefaultProps: function () {
        return {
            showMoreMenu: false,
            canSaveApplication: true,
            showDownloadMenu: false
        };
    },
    handleSaveOnClick: function () {
        if (this.props.application && this.props.canSaveApplication === true) {
            ApplicationActions.saveApplication(this.props.product.value, this.props.application, this.props.clientIdentificationMode);
        } else {
            saving = true;
            ApplicationActions.updateIsSaveDisabled(false);
            ApplicationActions.validateApplicationSave();
            ApplicationActions.requestApplicationSave();
        }
    },
    handleMoreOnClick: function () {
        ApplicationActions.showMoreMenu(!this.props.showMoreMenu);
        if (this.props.showDownloadMenu) {
            ApplicationActions.showDownloadMenu(!this.props.showDownloadMenu);
        }
    },
    componentWillUpdate: function (nextProps) {
        if (saving && nextProps.application && nextProps.canSaveApplication === true) {
            saving = false;
            ApplicationActions.updateIsSaveDisabled(true);
            ApplicationActions.saveApplication(this.props.product.value, nextProps.application, this.props.clientIdentificationMode);
        }
    },
    setHeightOfSpacer: function(){
        var input = ReactDOM.findDOMNode(this);
        setHeightOfSpacer(input);
    },
    componentDidMount: function() {
        this.setHeightOfSpacer();
    },
    componentDidUpdate: function() {
        this.setHeightOfSpacer();
    },
    handleDownloadClick: function () {
        ApplicationActions.showDownloadMenu(!this.props.showDownloadMenu);
        if (this.props.showMoreMenu) {
            ApplicationActions.showMoreMenu(!this.props.showMoreMenu);
        }
    },
    getDownloadLink: function() {
        if (Products.isInvestment(this.props.product.value) && !Validators.requiredValidation(this.props.accountType)) {
            return null;
        } else {
            return <li><a onClick={this.handleDownloadClick}>Download</a></li>;
        }
    },
    render: function () {
        let userContext = window.NOA.userContext || {};
        const iconArrow = (this.props.showMoreMenu) ? 'icon icon-up-open' : 'icon icon-down-open';
        const saveDisabled = this.props.isSaveDisabled || userContext.isEmulation;
        const saveProp = saveDisabled ? 'disabled' : '';
        const downloadFormApplication = DownloadFormsHelper.getDownloadFormApplication(this.props.application);
        let saveLink = userContext.isAdviser ? <li><a className={saveProp} disabled={saveDisabled} onClick={this.handleSaveOnClick}>Save</a></li> : null;
        let downloadLink = this.getDownloadLink();
        return (
            <div>
                <nav className={ClassNames('navbar navbar-fixed-top navbar-header', { 'with-download' : this.props.showDownloadMenu })} id="NavigationBar">
                    <div className="container">
                        <BackButton onClick={this.props.backButtonUrl} />
                        <div className="pull-right visible-xs-inline visible-sm-inline"><a><i className="icon icon-menu"></i></a></div>
                        <ul className="pull-right hidden-xs hidden-sm">
                            {saveLink}
                            {downloadLink}
                            <li><a href={UrlService.getLogOffUrl()} target="_self">Exit</a></li>
                            <li><a onClick={this.handleMoreOnClick}><i className={iconArrow}></i> More</a></li>
                        </ul>
                    </div>
                    <DownloadMenu content={this.props.download.content}
                        downloadFormApplication={downloadFormApplication}
                        productId={this.props.download.productId}
                        showDownloadMenu={this.props.showDownloadMenu}
                        enableDownloadButton={this.props.download.enableDownloadButton}
                        formsToDownload={this.props.download.formsToDownload}
                        downloadInProgress={this.props.download.downloadInProgress}
                        selectedForms={this.props.download.selectedForms}
                        readyForDownload={this.props.download.readyForDownload}
                        downloadFormsFailed={this.props.download.downloadFormsFailed}
                        downloadedForms={this.props.download.downloadedForms}
                        formDownloaded={this.props.download.formDownloaded}/>
                    <MoreMenu showMoreMenu={this.props.showMoreMenu} product={this.props.product} content={this.props.moreMenuContent} />
                </nav>
                <div className="NavigationBar__spacer" />
                <SaveApplicationNotification />
                <SlidingSessionNotification className="top-sticky-user-notification" />
                <ApplicationErrorNotification />
            </div>);
    }
});

module.exports = NavigationBar;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/NavigationBar.jsx